module.exports = __webpack_public_path__ + "static/media/pdficon.ea3a2d80.png";